import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  overflow: "visible",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.5935 8.04482L13.9997 13L9.45762 10.8703L10.7364 9.99671L8.05404 6.6131L6.99847 7.5196C6.15733 8.24196 4.8802 8.13953 4.16774 7.29257L0.229818 2.61129C-0.121163 2.19405 -0.0636919 1.57441 0.358183 1.22729C0.780058 0.88017 1.40658 0.937009 1.75756 1.35425L5.69548 6.03553L6.75105 5.12903C7.60931 4.39196 8.91667 4.51571 9.61799 5.4004L12.3745 8.87761L13.5935 8.04482Z",
      fill: "#621A4B"
    }, null, -1)
  ]))]))
}
export default { render: render }